import { Grid } from "@mui/material";
import React from "react";
import {CheckoutFormTypeFields, useCheckoutForm} from "./hooks/useCheckoutForm";
import {ControlledTextField} from "../forms/ControlledTextField";
import {OrderDeliveryAddressFields} from "../../types/purchaseOrder/Order";
import {AsyncSelect} from "../forms/AsyncSelect";
import { HttpCache } from "../../http";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";


export const DeliveryAddressInformationSection: React.FC = () => {
  const { methods } = useCheckoutForm();
  const baseName = CheckoutFormTypeFields.DeliveryAddress;
  
  return (
    <Grid container spacing={2} mb={2}>
      <Grid size={12}>
        Facturación y Entrega
      </Grid>
      
      <Grid size={{ xs: 12, md: 7, lg: 8 }}>
        <ControlledTextField control={methods.control}
                             label={"Calle"}
                             name={`${baseName}.${OrderDeliveryAddressFields.Street}`}
                             required
                             inputProps={{ maxLength: CHECKOUT_MAXLEN.vchCalle }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 5, lg: 4 }}>
        <ControlledTextField control={methods.control}
                             label={"Número"}
                             name={`${baseName}.${OrderDeliveryAddressFields.StreetNumber}`}
                             inputProps={{ maxLength: CHECKOUT_MAXLEN.vchCalleNro }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4, lg: 3 }}>
        <ControlledTextField control={methods.control}
                             label={"Piso / Departamento"}
                             name={`${baseName}.${OrderDeliveryAddressFields.FloorApartment}`}
                             inputProps={{ maxLength: CHECKOUT_MAXLEN.vchPisoDpto }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4, lg: 5 }}>
        <AsyncSelect label={"Provincia"}
                     loadOptions={HttpCache.getProvincies}
                     control={methods.control}
                     name={`${baseName}.${OrderDeliveryAddressFields.ProvinceCode}`}
                     required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4, lg: 4 }}>
        <ControlledTextField control={methods.control}
                             label={"Localidad"}
                             name={`${baseName}.${OrderDeliveryAddressFields.LocalityDesc}`}
                             required
                             inputProps={{ maxLength: CHECKOUT_MAXLEN.vchDescLocalidad }}
        />
      </Grid>
    </Grid>
  )
}














